export default "__VITE_ASSET__DJTAnUOp__"